/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 金銭区分
 * @export
 * @enum {number}
 */
export enum MoneyCategoryEnum {
    /** 海外アプリPF決済売上 */
    OVERSEAS_APP_PLATFORM_SALES = 0,
    /** チップ（非課税） */
    TIP = 1,
    /** キャンセル料（非課税） */
    CANCELLATION_FEE = 2,
    /** 乗車料金 */
    TAXIFARE = 3
}

/**
 * 金銭区分 の Union 型
 * @export
 * @typedef MoneyCategory
 */
export type MoneyCategory =
  typeof MoneyCategoryEnum[keyof typeof MoneyCategoryEnum];

/**
 * 金銭区分 のラベルマップ
 * @export
 */
export const MoneyCategoryLabels = {
    /**
     * 数値キー: MoneyCategoryEnum.OVERSEAS_APP_PLATFORM_SALES
     * 名前キー:  OVERSEAS_APP_PLATFORM_SALES
     */
    [MoneyCategoryEnum.OVERSEAS_APP_PLATFORM_SALES]: '海外アプリPF決済売上',
    OVERSEAS_APP_PLATFORM_SALES:                             '海外アプリPF決済売上',
    /**
     * 数値キー: MoneyCategoryEnum.TIP
     * 名前キー:  TIP
     */
    [MoneyCategoryEnum.TIP]: 'チップ（非課税）',
    TIP:                             'チップ（非課税）',
    /**
     * 数値キー: MoneyCategoryEnum.CANCELLATION_FEE
     * 名前キー:  CANCELLATION_FEE
     */
    [MoneyCategoryEnum.CANCELLATION_FEE]: 'キャンセル料（非課税）',
    CANCELLATION_FEE:                             'キャンセル料（非課税）',
    /**
     * 数値キー: MoneyCategoryEnum.TAXIFARE
     * 名前キー:  TAXIFARE
     */
    [MoneyCategoryEnum.TAXIFARE]: '乗車料金',
    TAXIFARE:                             '乗車料金',
} as const;

/**
 * 金銭区分 のラベル Union 型
 * @export
 * @typedef MoneyCategoryLabel
 */
export type MoneyCategoryLabel =
  typeof MoneyCategoryLabels[keyof typeof MoneyCategoryLabels];

/**
 * 金銭区分 のラベル取得関数
 * @export
 * @param { MoneyCategory } value - 列挙体の値
 * @returns { MoneyCategoryLabel } ラベル文字列
 */
export function getMoneyCategoryLabel(
  value: MoneyCategory
): MoneyCategoryLabel {
  return MoneyCategoryLabels[value];
}

/**
 * 金銭区分 のラベル配列を取得する関数
 * @export
 * @param { MoneyCategory[] } values - 列挙体の値配列
 * @returns { MoneyCategoryLabel[] } ラベル文字列配列
 */
export function getMoneyCategoryLabels(values: MoneyCategory[]): MoneyCategoryLabel[] {
  return values.map((value) => getMoneyCategoryLabel(value));
}

/**
 * 金銭区分 のラベル配列
 * @export
 */
export const MoneyCategoryLabelList = [
  '海外アプリPF決済売上','チップ（非課税）','キャンセル料（非課税）','乗車料金',
] as const;

